<template>
  <div class="picture">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
      <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"></breadcrumb>
      <section class="section-main">
        <div class="section-middle">
          <div class="section-middle-picture">
            <li class="picture-list" v-for="item in pictureList" :key="item.id" @click="toDetail(item.id, item.type)">
              <div class="picture-list-img">
              <img v-for="img in item.pictureVideoFileList" :key="img.id" :src="img.url" alt="">
              </div>
              <div class="picture-list-title">{{item.title}}</div>
            </li>
          </div>
          <div class="clear"></div>
          <el-pagination
              :page-size="pageSize"
              :current-page.sync="page"
              layout="total,prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :total="totalPage">
          </el-pagination>
        </div>
      </section>

  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb/index'
import {fetchList} from "@/network/scientificRearch/picturevideo";
import otherNav from '@/components/navBar/otherNav'
export default {
  name: "picture",
  components: { breadcrumb, otherNav },
  data() {
    return {
    path: '',
    name: '',
      childName:'',
      childPath:'',
      pictureList: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      type: 'picture',
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '科考影像'
    })
  },
  mounted() {
    this.getList()
  },

  created() {
    this.childName = '图片'
    this.childPath = this.$route.path
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.type
      })).then(response => {
        // console.log('123:',response)
        this.pictureList = response.data.data.records
        this.totalPage = response.data.data.total
      })
    },
    toDetail(id, type) {
      // console.log(id, type)
      this.$router.push('/detail/'+ id + '/' +type)
    },
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/picture";
.clear {
  clear: both;
}
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>